import { render, staticRenderFns } from "./YclientsResolver.vue?vue&type=template&id=c490e336&scoped=true"
import script from "./YclientsResolver.vue?vue&type=script&lang=ts"
export * from "./YclientsResolver.vue?vue&type=script&lang=ts"
import style0 from "./YclientsResolver.vue?vue&type=style&index=0&id=c490e336&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c490e336",
  null
  
)

export default component.exports